import React from 'react'
import { APP_SETTINGS } from '../../../constants/settings'

interface RecipeNavigationProps {
  currentStep: number
  totalSteps: number
  onPrevious: () => void
  onNext: () => void
  onShowIngredients: () => void
  hasTouchScreen: boolean
}

const RecipeNavigation: React.FC<RecipeNavigationProps> = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  onShowIngredients,
  hasTouchScreen
}) => {
  // Use different sizes based on device type
  const buttonSize = hasTouchScreen ? 
    APP_SETTINGS.TOUCH_TARGET_SIZE : 
    APP_SETTINGS.TOUCH_TARGET_SIZE * 1.2
  
  const buttonStyle = {
    width: `${buttonSize}px`,
    height: `${buttonSize}px`,
  }
  
  return (
    <div className={`flex ${hasTouchScreen ? 'justify-between' : 'justify-center space-x-8'} items-center w-full py-4 px-8 bg-gray-800 bg-opacity-90 border-t border-gray-700`}>
      {/* Previous Button */}
      <button
        onClick={onPrevious}
        disabled={currentStep === 0}
        className={`rounded-full flex items-center justify-center transition-colors ${
          currentStep === 0 ? 'text-gray-500 bg-gray-700' : 'text-white bg-green-800 hover:bg-green-700'
        }`}
        style={buttonStyle}
        aria-label="Previous step"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      
      {/* Show Ingredients Button */}
      <button
        onClick={onShowIngredients}
        className="rounded-lg bg-gray-700 hover:bg-gray-600 text-white px-6 py-3 transition-colors"
        aria-label="Show ingredients"
      >
        <div className="flex items-center space-x-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
          <span>Ingredients</span>
        </div>
      </button>
      
      {/* Step Indicator */}
      <div className="text-white text-lg font-medium">
        {currentStep + 1} / {totalSteps}
      </div>
      
      {/* Next Button */}
      <button
        onClick={onNext}
        disabled={currentStep === totalSteps - 1}
        className={`rounded-full flex items-center justify-center transition-colors ${
          currentStep === totalSteps - 1 ? 'text-gray-500 bg-gray-700' : 'text-white bg-green-800 hover:bg-green-700'
        }`}
        style={buttonStyle}
        aria-label="Next step"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  )
}

export default RecipeNavigation
